// EmailJS Configuration
export const EMAILJS_SERVICE_ID = "service_4cbqgdg";
export const EMAILJS_TEMPLATE_ID = "template_dw4a2ia";
export const EMAILJS_PUBLIC_KEY = "o421o2WuHWW0Q-CMJ";

// Contact Information
export const CONTACT_MOBILE = "+1-548-881-0012";
export const CONTACT_EMAIL = "info@thetrivedisolutions.com";
export const CONTACT_ADDRESS = "Canada";